module.exports = __webpack_public_path__ + "res/parts_icon.png";